import { atom, type WritableAtom } from "jotai";

type AtomWithKey<T> = WritableAtom<T, [T], void> & {
  key: string;
  initialValue: T;
};

/**
 * Drop-in replacement for Recoil's atom() that preserves the string key.
 * Usage: atomWithKey({ key: "myAtom", default: initialValue })
 *
 * `initialValue` is captured on the atom so reset helpers can restore it
 * without maintaining a parallel defaults table that would drift.
 */
export function atomWithKey<T>(config: { key: string; default: T }): AtomWithKey<T> {
  const jotaiAtom = atom<T>(config.default) as unknown as AtomWithKey<T>;
  jotaiAtom.key = config.key;
  jotaiAtom.debugLabel = config.key;
  jotaiAtom.initialValue = config.default;
  return jotaiAtom;
}
